import { useQuery } from "@tanstack/react-query";
import { fetchKPIResult } from "PFCore/services/kpi/fetch_kpi_result";
import { Id, QueryOptions } from "PFCore/types";
import { KPIResult } from "PFCore/types/kpi";

import { KPIKeys } from "./query_keys";

export const useKPIResult = (indicatorId: Id, engagementId: Id, options: QueryOptions<KPIResult> = {}) =>
  useQuery<KPIResult>({
    queryKey: KPIKeys.kpiResult(engagementId, indicatorId),
    queryFn: () => fetchKPIResult(engagementId, indicatorId),
    staleTime: 0,
    retry: false,
    ...options
  });
